document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const currentUrl = window.location.href;

    if (!currentUrl.includes("variant")) {
      const selectElement = document.querySelector(
        '[data-pf-type="ProductBox"] .pf-variant-select'
      );
      const optionCount = selectElement.options.length;
      const placeholderText = `Select model number (${optionCount})`;

      const placeholderOption = document.createElement("option");
      placeholderOption.textContent = placeholderText;
      placeholderOption.value = "";
      placeholderOption.disabled = true;
      placeholderOption.selected = true;

      selectElement.insertBefore(placeholderOption, selectElement.firstChild);

      const variantLabel = document.querySelector(
        ".variantName .selected.variant"
      );

      if (variantLabel) {
        variantLabel.textContent = "Select model number";
      }

      selectElement.addEventListener("focus", function () {
        if (selectElement.contains(placeholderOption)) {
          placeholderOption.remove();
        }
      });

      const addToCartButton = document.querySelector(
        '[data-pf-type="ProductATC2"]'
      );
      const variantSelect = document.querySelector(".pf-variant-select");
      const buttonWrapper = addToCartButton.closest("div");
      const messageSpan = document.createElement("span");

      const checkOptions = () => {
        const options = variantSelect.options;
        let hasDisabledOption = false;

        for (let i = 0; i < options.length; i++) {
          if (options[i].disabled) {
            hasDisabledOption = true;
            break;
          }
        }

        if (hasDisabledOption) {
          addToCartButton.disabled = true;
        } else {
          addToCartButton.disabled = false;
        }
      };

      buttonWrapper.addEventListener("click", (event) => {
        const stockCountWrapper = document.querySelector(".pf-option-swatches");

        if (addToCartButton.disabled) {
          messageSpan.innerHTML = `
               <span data-testid="mui-error-exclamation" class="mui-error-exclamation" style="color: rgb(204, 62, 62); font-size: 12px; font-weight: 400; line-height: 1.6rem; margin-left: 0.8rem;">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7.38442 3.77756V9.19295H8.61519V3.77756H7.38442ZM8.94655 11.2758C8.94655 11.7987 8.52268 12.2225 7.9998 12.2225C7.47693 12.2225 7.05306 11.7987 7.05306 11.2758C7.05306 10.7529 7.47693 10.329 7.9998 10.329C8.52268 10.329 8.94655 10.7529 8.94655 11.2758Z" fill="rgb(204, 62, 62)"></path>
    </svg>
    Please select a model number
</span>

            `;

          const style = document.createElement("style");
          style.innerHTML = `
    .mui-error-exclamation {
        display: flex;
        margin-left: 0px !important;
    }
    .mui-error-exclamation svg {
        margin-right: 8px;
    }
`;
          document.head.appendChild(style);
          const selectElement = stockCountWrapper.querySelector("select");

          if (stockCountWrapper.querySelector("span")) {
            stockCountWrapper.querySelector("span").remove();
          }

          stockCountWrapper.appendChild(messageSpan);

          selectElement.style.border = "1px solid rgb(204, 62, 62)";
        } else {
          selectElement.style.border = "1px solid  #d1d5db";
          addToCartButton.click();
        }
      });

      checkOptions();

      variantSelect.addEventListener("click", () => {
        const variantHover = document.querySelector(
          ".variantName .hover.variant"
        );
        console.log(variantHover.textContent, "variantHover.textContent");

        variantLabel.textContent = variantHover.textContent;
        if (messageSpan.parentNode) {
          selectElement.style.border = "1px solid  #d1d5db";
          messageSpan.parentNode.removeChild(messageSpan);
        }
        checkOptions();
      });
    }
  }, 1000);
});
